export const setParties = (state, payload) => {
  state.parties = payload;
};

export const setParty = (state, payload) => {
  state.party = payload;
};

export const setAssociations = (state, payload) => {
  state.associations = payload;
};

